const pad = (value, width = 2) => String(value).padStart(width, '0')

function validCivil(year, month, day, hour, minute, second) {
  if (year < 1000 || year > 9999 || hour > 23 || minute > 59 || second > 59) return false
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second))
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
    && date.getUTCHours() === hour && date.getUTCMinutes() === minute && date.getUTCSeconds() === second
}

export function isHistoryInstant(value, { exclusiveEnd = false } = {}) {
  if (typeof value !== 'string') return false
  if (exclusiveEnd && /^\+010000-01-01T00:00:00(?:\.0+)?Z$/.test(value)) return true
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.exec(value)
  return Boolean(match && validCivil(...match.slice(1, 7).map(Number)) && Number.isFinite(Date.parse(value)))
}

export function currentDayRange(now = new Date(), { utc = false } = {}) {
  const from = new Date(now)
  if (utc) from.setUTCHours(0, 0, 0, 0)
  else from.setHours(0, 0, 0, 0)
  const to = new Date(from)
  if (utc) to.setUTCDate(to.getUTCDate() + 1)
  else to.setDate(to.getDate() + 1)
  return { from: from.toISOString(), to: to.toISOString() }
}

export function isCurrentDayRange(from, to, now = new Date(), options = {}) {
  const day = currentDayRange(now, options)
  return from === day.from && to === day.to
}

export function nativeDateTimeInput(value, { utc = false, inclusiveEnd = false, includeSeconds = true } = {}) {
  if (!value) return ''
  if (!isHistoryInstant(value, { exclusiveEnd: inclusiveEnd })) return value
  const date = new Date(Date.parse(value) - (inclusiveEnd ? 1000 : 0))
  const part = name => date[`${utc ? 'getUTC' : 'get'}${name}`]()
  const day = `${pad(part('FullYear'), 4)}-${pad(part('Month') + 1)}-${pad(part('Date'))}`
  const time = `${pad(part('Hours'))}:${pad(part('Minutes'))}`
  // Native controls omit zero seconds; avoid rewriting the selected year segment.
  return `${day}T${time}${includeSeconds && part('Seconds') ? `:${pad(part('Seconds'))}` : ''}`
}

export function nativeDateTimeInstant(value, { utc = false, inclusiveEnd = false } = {}) {
  if (!value) return ''
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value)
  if (!match) return value
  const [year, month, day, hour, minute, second] = match.slice(1).map(item => Number(item ?? 0))
  if (!validCivil(year, month, day, hour, minute, second)) return value
  const date = utc ? new Date(Date.UTC(year, month - 1, day, hour, minute, second))
    : new Date(year, month - 1, day, hour, minute, second)
  if (!utc && (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day
    || date.getHours() !== hour || date.getMinutes() !== minute || date.getSeconds() !== second)) return value
  return new Date(date.getTime() + (inclusiveEnd ? 1000 : 0)).toISOString()
}

export function utcFieldsInput(fields) {
  const date = /^(\d{2})\.(\d{2})\.(\d{4,})$/.exec(fields?.date ?? '')
  const time = /^(\d{2}):(\d{2}):(\d{2})$/.exec(fields?.time ?? '')
  if (!date || !time) return ''
  return `${date[3]}-${date[2]}-${date[1]}T${time[1]}:${time[2]}${time[3] !== '00' ? `:${time[3]}` : ''}`
}

export function utcFieldsFromInput(value) {
  const match = /^(\d{4,})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value)
  return match ? { date: `${match[3]}.${match[2]}.${match[1]}`, time: `${match[4]}:${match[5]}:${match[6] ?? '00'}` }
    : { date: '', time: '' }
}
